import {
  Box,
  Grid,
  TextField,
  InputAdornment,
  Button,
  Paper,
} from "@mui/material";
import { DataGrid } from "@mui/x-data-grid";
import SearchIcon from "@mui/icons-material/Search";
import AddIcon from "@mui/icons-material/Add";
// import EditIcon from "@mui/icons-material/Edit";
import { useNavigate } from "react-router-dom";
import AppBreadcrumbs from "../../components/AppBreadcrumbs";
import * as services from "./../../services/saleng";
import { useState, useEffect } from "react";
import dayjs from "dayjs";
import "dayjs/locale/th";
import localizedFormat from "dayjs/plugin/localizedFormat";

dayjs.extend(localizedFormat);
dayjs.locale("th");

export default function TransformTransactionsTemplate() {
  const [transactions, setTransactions] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [search, setSearch] = useState("");
  const navigate = useNavigate();

  useEffect(() => {
    async function fetchData() {
      setLoading(true);
      setError(null);
      try {
        const res = await services.getTransformTransaction();
        const transformTransaction = res.data.data;
        console.log("transformTransaction ", transformTransaction);
        setTransactions(transformTransaction || []);
      } catch (err) {
        setError(err.message || "Unknown error");
      } finally {
        setLoading(false);
      }
    }
    fetchData();
  }, []);

  // แปลง transactions เป็น rows สำหรับ DataGrid
  const rows = transactions.map((t, index) => ({
    id: index,
    date: dayjs(t.createdAt).add(543, "year").format("DD MMM YYYY เวลา HH:mm"),
    origin: t.origin.title,
    origin_weight: t.originWeight,
    destination: t.destination.title,
    destination_weight: t.destinationWeight,
    transformed_by: `${t.transformer.name} ${t.transformer.lastname}`,
  }));

  // กำหนด columns สำหรับ DataGrid
  const columns = [
    { field: "date", headerName: "ณ วันที่", flex: 2 },
    { field: "origin", headerName: "ต้นทาง", flex: 1.5 },
    { field: "origin_weight", headerName: "น้ำหนัก", flex: 1.5 },
    { field: "destination", headerName: "ปลายทาง", flex: 1.5 },
    { field: "destination_weight", headerName: "น้ำหนัก", flex: 1.5 },
    { field: "transformed_by", headerName: "แปรสภาพโดย", flex: 1 },
    // {
    //   field: "actions",
    //   headerName: "จัดการ",
    //   flex: 0.5,
    //   sortable: false,
    //   renderCell: (params) => (
    //     <IconButton
    //       color="primary"
    //       onClick={() => {
    //         // ไปหน้าจอแก้ไข หรือแสดงรายละเอียด
    //         navigate(`/edit_transform/${params.row.id}`);
    //       }}
    //     >
    //       <EditIcon />
    //     </IconButton>
    //   ),
    // },
  ];

  if (loading) return <Box sx={{ p: 2 }}>Loading transactions...</Box>;
  if (error) return <Box sx={{ p: 2, color: "red" }}>Error: {error}</Box>;

  return (
    <Box p={2}>
      <AppBreadcrumbs />

      {/* Search & Button */}
      <Grid
        container
        spacing={2}
        alignItems="center"
        justifyContent="space-between"
        sx={{ my: 0 }}
      >
        <Grid item xs={12} sm={8} md={6}>
          <TextField
            fullWidth
            placeholder="ค้นหารายละเอียด"
            value={search}
            onChange={(e) => setSearch(e.target.value)}
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">
                  <SearchIcon />
                </InputAdornment>
              ),
            }}
          />
        </Grid>

        <Grid item xs={12} sm={4} md="auto">
          <Button
            variant="contained"
            color="primary"
            startIcon={<AddIcon />}
            onClick={() => navigate("exchange")}
            size="large"
            fullWidth
          >
            เริ่มแปรสภาพ
          </Button>
        </Grid>
      </Grid>

      {/* DataGrid */}
      <Paper sx={{ mt: 2 }}>
        <div style={{ height: 500, width: "100%" }}>
          <DataGrid
            rows={rows.filter(
              (row) =>
                row.origin.toLowerCase().includes(search.toLowerCase()) ||
                row.destination.toLowerCase().includes(search.toLowerCase()) ||
                row.transformed_by.toLowerCase().includes(search.toLowerCase())
            )}
            columns={columns}
            loading={loading}
            disableRowSelectionOnClick
            localeText={{
              noRowsLabel: "ไม่พบข้อมูล",
            }}
          />
        </div>
      </Paper>
    </Box>
  );
}
